import { dateConvertTimezone } from "src/app/platform/utils/functions";

export class ProceduresData {
    id: number;
    status: string;
    detail: string;
    medium: string;
    reason: string;
    type: string;
    dateStart: string;
    dateEnd: string;

    constructor() {
        this.id = 0;
        this.status = '';
        this.detail = '';
        this.medium = '';
        this.reason = '';
        this.type = '';
        this.dateStart = '';
        this.dateEnd = '';
    }

    configData(parameters: any): ProceduresData{
        this.id = parameters.id;
        this.status = parameters.estado;
        this.detail = parameters.observaciones;
        this.medium = parameters.medio;
        this.reason = parameters.motivo;
        this.type = parameters.tipo;
        this.dateStart = dateConvertTimezone(new Date(parameters.fechaInicio), 'Etc/Greenwich');
        this.dateEnd = dateConvertTimezone(new Date(parameters.fechaFinalizacion), 'Etc/Greenwich');

        return this;
    }
}

export class AreaData {
    id: number;
    name: string;

    constructor() {
        this.id = 0;
        this.name = '';
    }

    configData(parameters: any): AreaData{
        this.id = parameters.id;
        this.name = parameters.nombre;

        return this;
    }
}

export class ReasonData {
    id: number;
    name: string;
    area: number;

    constructor() {
        this.id = 0;
        this.name = '';
        this.area = 0;
    }

    configData(parameters: any): ReasonData{
        this.id = parameters.id;
        this.name = parameters.nombre;
        this.area = parameters.area.id;

        return this;
    }
}
